<template>
  <div class="form-group">
    <label for="name">{{title}}</label>
    <select class="form-control color-option-default"
      name="color"
      :value="color"
      :style="{ backgroundColor: color, color: getTextColor(color) }"
      @change="updateColor($event.target.value)">
        <option
          v-for="item in currentPalette"
          :key="item"
          :value="item"
          :style="getOptionStyle(item)"
          selected>{{ item }}</option>
    </select>
  </div>
</template>
<script>

export default {
  props: {
    color: {
      type: String,
      default: '#c850c0'
    },
    palette: {
      type: String,
      default: 'colors'
    },
    title: {
      type: String,
      default: 'Color'
    }
  },
  methods: {
    updateColor (newColor) {
      this.$emit('color-change', newColor)
    },
    getOptionStyle (color) {
      return {
        backgroundColor: color,
        color: this.getTextColor(color)
      }
    },
    getTextColor (color) {
      const rgb = this.hexToRgb(color)
      if (!rgb) {
        return '#111'
      }
      const luminance = (0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b) / 255
      return luminance > 0.6 ? '#111' : '#fff'
    },
    hexToRgb (hex) {
      if (!hex) {
        return '#000000'
      }
      const match = hex.replace('#', '')
      if (match.length === 3) {
        const [r, g, b] = match.split('')
        return {
          r: parseInt(r + r, 16),
          g: parseInt(g + g, 16),
          b: parseInt(b + b, 16)
        }
      }
      if (match.length === 6) {
        return {
          r: parseInt(match.slice(0, 2), 16),
          g: parseInt(match.slice(2, 4), 16),
          b: parseInt(match.slice(4, 6), 16)
        }
      }
      return null
    }
  },
  computed: {
    currentPalette () {
      return this.palettes[this.palette] || this.palettes.colors
    }
  },
  data () {
    return {
      palettes: {
        colors: {
          default: '#c850c0',
          black: '#000',
          yumGrey: '#626262',
          yumOrange: '#FF5500',
          kioskGrey: '#F1F1F1'
        },
        odsColors: {
          default: '#c850c0',
          white: '#FFF',
          black: '#000',
          yumGrey: '#8c8c8c',
          yumOrange: '#FF5500',
          tyranosaurusRed: '#D22538',
          carrotOrange: '#ED7117',
          tapTastyOrange: '#f3bb45', // definitely yellow
          tapTastyGreen: '#7ac29a',
          yumBlue: '#0055ff'
        }
      }
    }
  }
}
</script>

<style scoped>
.color-option-default {
  color: #111;
}

.color-option-default option {
  border: 2px solid transparent;
  box-shadow: inset 0 0 0 2px transparent;
  color: inherit;
  font-weight: 600;
  text-transform: uppercase;
  padding: 4px;
}

.color-option-default option:hover,
.color-option-default option:focus {
  border: 2px solid #111;
  box-shadow: inset 0 0 0 2px #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/UIComponents/BackgroundColorPicker.vue